import { useEffect, useState } from 'react';
import { Outlet } from '@tanstack/react-router';

import { activeThemeId } from '@/theme/theme-config';
import { applyThemeTokens } from '@/theme/theme-mapper';
import { ThemeSwitcher } from '@/theme/theme-switcher';

export function RootComponent() {
  // 临时：?theme-preview=1 时显示主题预览切换器（staging 测试用，不入生产 UI）。
  const [themePreview] = useState(
    () =>
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).has('theme-preview'),
  );

  // 生产路径显式应用 status-quo 主题：组件不再依赖隐式默认值，
  // 未来切换主题 = 更换配方（applyThemeTokens(themeId)）。
  useEffect(() => {
    if (!themePreview) {
      applyThemeTokens(activeThemeId);
    }
  }, [themePreview]);

  return (
    <>
      <Outlet />
      {themePreview ? <ThemeSwitcher /> : null}
    </>
  );
}
